<div class="flex flex-col items-end gap-1 p-4">
  <button
    mat-flat-button
    color="primary"
    (click)="accApi.syncRequests(this.patient()?.ref)"
  >
    Sync ACC Requests
  </button>
</div>

<div class="rounded-sm shadow-md">
  @if (noInvoices$ | async) {
    <pr-empty-state image="list" title="ACC invoices" />
  } @else {
    <table
      mat-table
      matSort
      matSortActive="createdAt"
      matSortDirection="desc"
      class="w-full"
      [dataSource]="dataSource"
    >
      <ng-container matColumnDef="status">
        <th *matHeaderCellDef mat-header-cell class="w-32">Status</th>
        <td *matCellDef="let data" mat-cell class="w-32">
          <pr-status-label
            class="w-20"
            [label]="data.status"
            [color]="data.status | map: getStatusColour"
            [dense]="true"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Created</th>
        <td *matCellDef="let data" mat-cell>
          {{ data.createdAt | moment | amDateFormat: dateFormat }}
        </td>
      </ng-container>

      <ng-container matColumnDef="invoiceId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
          ACC Invoice ID
        </th>
        <td *matCellDef="let data" mat-cell>
          @if (data.data.invoice?.invoiceId; as invoiceId) {
            {{ invoiceId }}
          }
          @if (data.data.testMode) {
            <pr-acc-test-chip />
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="claimNumber">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Claim Number</th>
        <td *matCellDef="let data" mat-cell>
          {{ data | map: getClaimNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="patient">
        <th *matHeaderCellDef mat-header-cell>Patient</th>
        <td *matCellDef="let data" mat-cell>
          <a
            class="text-blue-500"
            [routerLink]="data.patient | map: getPatientLink : this"
          >
            {{ data.patient.name }}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="invoiceLink">
        <th *matHeaderCellDef mat-header-cell>Invoice Link</th>
        <td *matCellDef="let data" mat-cell class="text-center">
          @if (data.data.invoiceRef; as invoiceRef) {
            <a
              class="text-blue-500 opacity-80"
              [routerLink]="invoiceRef | map: invoiceLink$ : this | async"
            >
              <button mat-icon-button>
                <mat-icon fontSet="material-symbols-outlined">article</mat-icon>
              </button>
            </a>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="syncStatus">
        <th *matHeaderCellDef mat-header-cell>Sync Status</th>
        <td *matCellDef="let data" mat-cell>
          <div>
            @if (data.errorMessage) {
              <mat-icon
                class="text-warn-500 opacity-80"
                [matTooltip]="data.errorMessage"
              >
                sync_problem
              </mat-icon>
            } @else if (data.cloudTaskId) {
              <mat-spinner matTooltip="Sync in progress..." [diameter]="20" />
            } @else if (data.syncedAt) {
              <mat-icon
                class="text-green-500 opacity-80"
                [matTooltip]="
                  data.syncedAt | moment | amDateFormat: dateTimeFormat
                "
              >
                published_with_changes
              </mat-icon>
            } @else {
              <mat-icon matTooltip="Not Synced" class="opacity-50">
                sync
              </mat-icon>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th *matHeaderCellDef mat-header-cell class="text-right">Actions</th>
        <td *matCellDef="let data" mat-cell class="text-right">
          <button
            mat-icon-button
            [matMenuTriggerFor]="moreMenu"
            [matMenuTriggerData]="{ invoice: data }"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      @if (displayedColumns(); as displayedColumns) {
        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
        <tr *matNoDataRow class="mat-row">
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            No ACC Invoices found.
          </td>
        </tr>
      }
    </table>

    <mat-paginator
      #paginator
      showFirstLastButtons
      [length]="dataSource.data.length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
    />

    <mat-menu #moreMenu="matMenu">
      <ng-template let-invoice="invoice" matMenuContent>
        <button
          mat-menu-item
          [disabled]="!invoice.data.invoice"
          (click)="viewInvoiceDetails(invoice)"
        >
          <mat-icon fontSet="material-symbols-outlined" class="opacity-80">
            table_eye
          </mat-icon>
          <span>View Invoice Details</span>
        </button>

        <button
          mat-menu-item
          [disabled]="invoice | map: deleteDisabled : this"
          (click)="accInvoiceService.deleteInvoice(invoice)"
        >
          <mat-icon
            fontSet="material-symbols-outlined"
            class="!text-warn-500 opacity-80"
          >
            delete
          </mat-icon>
          <span>Delete Invoice</span>
        </button>
      </ng-template>
    </mat-menu>
  }
</div>
